import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { PawPrint, Home as HomeIcon } from "lucide-react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";

const Error404 = () => {
  useEffect(() => { document.title = "404 – Moggies & Doggies Veterinary Care"; }, []);
  return (
    <div className="min-h-screen bg-white font-body text-pawelle-body">
      <SiteHeader />
      <main className="relative flex min-h-[80vh] items-center justify-center overflow-hidden bg-pawelle-bg px-5 pt-24 text-center">
        <PawPrint className="pointer-events-none absolute left-12 top-32 h-24 w-24 -rotate-12 text-white opacity-70" />
        <PawPrint className="pointer-events-none absolute bottom-20 right-16 h-20 w-20 text-white opacity-70" />
        <PawPrint className="pointer-events-none absolute left-1/4 bottom-16 h-12 w-12 text-white opacity-60" />
        <div className="relative">
          <h1 className="font-display text-[120px] font-bold leading-none text-pawelle-primary md:text-[180px]">404</h1>
          <h2 className="mt-2 font-display text-[28px] font-bold uppercase text-pawelle-ink md:text-[40px]">Oops! Page Not Found</h2>
          <p className="mx-auto mt-4 max-w-md font-body text-[16px] text-pawelle-body">
            The page you're looking for may have wandered off like a curious pup. Let's get you back home.
          </p>
          <Link to="/gb/en/home.html" className="mt-8 inline-flex items-center gap-2 rounded-full bg-pawelle-primary px-8 py-4 font-display text-[16px] font-medium text-white transition-all duration-300 hover:bg-pawelle-primary-dark hover:-translate-y-0.5">
            <HomeIcon className="h-5 w-5" /> Back to Home
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Error404;
